// extracted by mini-css-extract-plugin
export default {"inputColor":"styles_inputColor__XRc7x","emailIDReadOnly":"styles_emailIDReadOnly__4frdN","externalUserInfoFormField":"styles_externalUserInfoFormField__95u3M"};